<template>
    <div v-loading="loading">
        <apply-header :flag="'0'"></apply-header>
        <div class="main">
            <Side :step="'1'"></Side>
            <section>
                <div style="color:#999;font-size:20px;font-weight:700;">Step 1</div>
                <div class="pageTitle">
                    eAssist Application
                    <span style="color:#FE5442;font-size:18px;">* Required</span>
                </div>
                <div class="pageSectionTitle">CONTACT INFO</div>
                <el-form ref="form" :model="form" label-position="top"  :inline="true" :rules="rules1">
                    <el-form-item label="First Name" prop="firstName">
                        <el-input ref="firstName" v-model="form.firstName" style="width:250px;" :disabled="isAdmin"></el-input>
                    </el-form-item>
                    <el-form-item label="Middle Name" prop="middleName">
                        <el-input ref="middleName" v-model="form.middleName" style="width:150px;" :disabled="isAdmin"></el-input>
                    </el-form-item>
                    <el-form-item label="Last Name" prop="lastName">
                        <el-input ref="lastName" v-model="form.lastName" style="width:200px;" :disabled="isAdmin"></el-input>
                    </el-form-item>
                    <el-form-item label="Preferred Name">
                        <el-input ref="preferredName" v-model="form.preferredName" style="width:200px;" :disabled="isAdmin"></el-input>
                    </el-form-item><br>
                    <el-form-item label="Email" prop="email">
                        <el-input ref="email" v-model="form.email" type="email" style="width:350px;" :disabled="isAdmin"></el-input>
                    </el-form-item><br>
                    <el-form-item label="Password" prop="password" v-show="!isAdmin&&!model">
                        <el-input ref="password" type="password" v-model="form.password" style="width:350px;" :disabled="isAdmin"></el-input>
                    </el-form-item>
                    <el-form-item label="Retype Password" prop="password2" v-show="!isAdmin&&!model">
                        <el-input ref="password2" type="password" v-model="form.password2" style="width:350px;" :disabled="isAdmin"></el-input>
                    </el-form-item><br>
                    <el-form-item label="Mobile Phone" prop="phone">
                        <div class="el-input">
                            <input :disabled="isAdmin" style="width:300px;" @change="changePhone" v-model="phone" class="el-input__inner" type="text" v-mask="/\(\d{3}\) \d{3}-\d{4}/">
                        </div>
                        <el-input :disabled="isAdmin" v-show="true" ref="phone" v-model="form.phone" style="width:280px" class="hideInput"></el-input>
                    </el-form-item><br>
                    <el-form-item label="Address" prop="address">
                        <el-input :disabled="isAdmin" ref="address" v-model="form.address" style="width:500px;"></el-input>
                    </el-form-item><br>
                    <el-form-item label="Zip Code" prop="zipCode">
                        <el-input :disabled="isAdmin" @keyup.native="changeCode" ref="zipCode" v-model="form.zipCode" style="width:280px;"></el-input>
                    </el-form-item>
                    <el-form-item label="City" prop="city">
                        <el-input ref="city" :disabled="disableCityAndState" v-model="form.city" style="width:300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="State" prop="state">
                        <el-input ref="state" :disabled="disableCityAndState" v-model="form.state" style="width:280px;"></el-input>
                    </el-form-item>
                    <el-button class="manually" type="primary" icon="el-icon-edit" @click="enableCityState">Manually Edit</el-button>
                    <el-form-item label="Country" prop="country">
                        <span slot="label"><span>Country</span><br/><span style="color: gray;"> (If you currently live in California or Massachusetts, please reach out to applicants@eAssist.me before proceeding.) </span></span>
                        <el-select placeholder="" ref="country" v-model="form.country" :disabled="isAdmin">
                            <el-option label="None" value=""></el-option>
                            <el-option label="USA" value="USA"></el-option>
                            <el-option label="Canada" value="Canada"></el-option>
                        </el-select>
                    </el-form-item><br>
                    <el-form-item label="Resume" prop="resumeUrl">
                        <el-upload
                            ref="resumeUrl"
                            class="upload-demo"
                            :action="this.$URL.uploadUrl"
                            :on-success="uploadSuccess"
                            :show-file-list="false"
                            :data="{baseDir:'Applicant/Apply'}"
                            accept=".doc,.docx,.DOC,.DOCX.,.pdf,.PDF"
                            :disabled="isAdmin">
                            <el-button style="background:#2EC4E3;border:1px solid #2EC4E3;font-weight:700;" type="primary" v-show="!isAdmin&&!form.resumeUrl">+ Add Files</el-button>
                            <span style="font-weight:700;font-size:22px;margin-left:30px" :class="[isAdmin?'underLine':'']" v-show="form.resumeUrl" @click="downloadFile(form.resumeUrl)">{{formateUrl(form.resumeUrl)}}</span>
                            <span @click="edit" style="font-weight:700;color:#C2C2C6;font-size:19px;margin-left:20px;cursor:pointer;" v-show="form.resumeUrl&&!isAdmin">Edit</span>
                            <span @click="remove" style="font-weight:700;color:#C2C2C6;font-size:19px;margin-left:10px;cursor:pointer;" v-show="form.resumeUrl&&!isAdmin">Remove</span>
                        </el-upload>
                    </el-form-item><br>
                    <hr style="margin:30px 0;">
                    <div class="pageSectionTitle">SKILL SET</div>
                    <el-form-item prop="yearsDentalExperience" label="How many years of dental experience have you had?">
                        <el-input :disabled="isAdmin" ref="yearsDentalExperience" v-model="form.yearsDentalExperience"
                                  style="width:300px;" oninput="this.value=(this.value.replace(/[^0-9]+/,'')).slice(0,11);"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="yearsFrontOfficeExperience" label="How many years of FRONT OFFICE dental experience have you had?">
                        <el-input :disabled="isAdmin" ref="yearsFrontOfficeExperience" v-model="form.yearsFrontOfficeExperience"
                                  style="width:300px;" oninput="this.value=(this.value.replace(/[^0-9]+/,'')).slice(0,11);"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="haveWorked" label="Have you worked for a dental office in the past 12 months?">
                        <el-select :disabled="isAdmin" placeholder="" ref="haveWorked" v-model="form.haveWorked" style="width:300px;">
                            <el-option label="None" value=""></el-option>
                            <el-option label="Yes" :value="true"></el-option>
                            <el-option label="No" :value="false"></el-option>
                        </el-select>
                    </el-form-item><br>
                    <el-form-item prop="languages" label="Which language(s) are you comfortable communicating in?">
                        <el-checkbox-group :disabled="isAdmin" class="specail" ref="languages" v-model="form.languages">
                            <el-checkbox label="Arabic">Arabic</el-checkbox>
                            <el-checkbox label="Chinese">Chinese</el-checkbox>
                            <el-checkbox label="English">English</el-checkbox>
                            <el-checkbox label="Japanese">Japanese</el-checkbox>
                            <el-checkbox label="Korean">Korean</el-checkbox>
                            <el-checkbox label="Russian">Russian</el-checkbox>
                            <el-checkbox label="Spanish">Spanish</el-checkbox>
                            <el-checkbox label="Other">Other
                                <el-input :disabled="isAdmin" v-show="form.languages.includes('Other')" v-model="form.languagesOther"></el-input>
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item><br>
                    <el-form-item label="Have you ever applied before?" prop="isApplied">
                        <el-select :disabled="isAdmin" placeholder="" ref="isApplied" v-model="form.isApplied" style="width:200px;">
                            <el-option label="Yes" :value="true"></el-option>
                            <el-option label="No" :value="false"></el-option>
                        </el-select>&nbsp;&nbsp;
                        <el-date-picker
                            v-show="this.form.isApplied == true"
                            ref="previousApplication"
                            v-model="form.previousApplication"
                            type="date"
                            placeholder=""
                            style="width:200px;"
                            :disabled="isAdmin">
                        </el-date-picker>
                        
                        <el-input 
                            v-if="form.isApplied === true" 
                            :disabled="isAdmin" 
                            ref="applyPreviousName" 
                            v-model="form.applyPreviousName" 
                            style="width:350px;margin-left:5px" 
                            placeholder="Previous Name Used to Apply"
                        ></el-input>
                    </el-form-item><br>
                    <el-form-item label="Are you legally authorized/eligible to provide services in the United States? (Proof of eligibility may be required.)">
                        <el-checkbox :disabled="isAdmin" ref="ableToWorkInUS" v-model="form.ableToWorkInUS"> Yes, I can legally work in the US.</el-checkbox>
                    </el-form-item><br>
                    <el-form-item label="Are you over the age of 18 years? (If no, you may be required to provide authorization) ">
                        <el-checkbox :disabled="isAdmin" ref="over18" v-model="form.over18"> Yes, I am over the age of 18.</el-checkbox>
                    </el-form-item><br>
                    <el-form-item prop="familyAteAssist" label="Do you have any friends or family that are employed by eAssist?">
                        <el-select :disabled="isAdmin" placeholder="" ref="familyAteAssist" v-model="form.familyAteAssist" style="width:300px;">
                            <el-option label="No" :value="false"></el-option>
                            <el-option label="Yes" :value="true"></el-option>
                        </el-select>
                        <el-input 
                            v-if="form.familyAteAssist === true" 
                            :disabled="isAdmin" 
                            ref="familyAteAssistName" 
                            v-model="form.familyAteAssistName" 
                            style="width:300px; margin-left: 10px;" 
                            placeholder="Name & Relation"
                        ></el-input>
                    </el-form-item><br>
                    <el-form-item prop="howLearned" label="How did you hear about this opportunity?">
                        <el-radio-group :disabled="isAdmin" class="specail" ref="howLearned" v-model="form.howLearned">
                            <el-radio :label="2">Search Engine</el-radio><br>
                            <el-radio :label="3">Word Of Mouth</el-radio><br>
                            <el-radio :label="4">Referral from Current eAssist Worker</el-radio><br>
                            <el-radio :label="6">Zip Recruiter</el-radio><br>
                            <el-radio :label="8">Indeed</el-radio><br>
                            <el-radio :label="10">Work / Worked in an eAssist supported practice</el-radio><br>
                            <el-radio :label="12">Trade Show / Convention</el-radio><br>
                            <el-radio :label="13">Facebook / Instagram</el-radio><br>
                            <el-radio :label="14">AADOM</el-radio><br>
                            <el-radio :label="15">Direct Dental</el-radio><br>
                            <el-radio :label="5">Other&nbsp;&nbsp;
                                <el-input :disabled="isAdmin" style="width:100px;" size="mini" v-show="form.howLearned == 5" v-model="form.howLearnedOther"></el-input>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item><br>
                    <el-form-item prop="expectedHours" label="How many hours per week are you wanting to provide services?">
                        <el-radio-group :disabled="isAdmin" class="specail" ref="expectedHours" v-model="form.expectedHours">
                            <el-radio label="Full-time">30-40 hours / week</el-radio><br>
                            <el-radio label="Part-time">10-20 hours / week</el-radio>
                        </el-radio-group>
                    </el-form-item><br>
                    <el-form-item prop="dentalOfficeManagmentSoftware" label="What dental office management software are you competent in? (select all that apply)">
                        <el-checkbox-group :disabled="isAdmin" class="specail" ref="dentalOfficeManagmentSoftware" v-model="form.dentalOfficeManagmentSoftware">
                            <el-checkbox label="Archy">Archy</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item30" v-show="form.dentalOfficeManagmentSoftware.includes('Archy')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Carestack">Carestack</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item31" v-show="form.dentalOfficeManagmentSoftware.includes('Carestack')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Cloud9">Cloud9</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item32" v-show="form.dentalOfficeManagmentSoftware.includes('Cloud9')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Curve">Curve</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item1" v-show="form.dentalOfficeManagmentSoftware.includes('Curve')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Denticon/Planet DDS">Denticon</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item20" v-show="form.dentalOfficeManagmentSoftware.includes('Denticon/Planet DDS')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Dentimax">Dentimax</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item9" v-show="form.dentalOfficeManagmentSoftware.includes('Dentimax')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Dentrix">Dentrix</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item2" v-show="form.dentalOfficeManagmentSoftware.includes('Dentrix')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Ascend">Dentrix Ascend</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item12" v-show="form.dentalOfficeManagmentSoftware.includes('Ascend')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Enterprise">Dentrix Enterprise</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item11" v-show="form.dentalOfficeManagmentSoftware.includes('Enterprise')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Dolphin">Dolphin</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item33" v-show="form.dentalOfficeManagmentSoftware.includes('Dolphin')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="DOX">DOX</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item34" v-show="form.dentalOfficeManagmentSoftware.includes('DOX')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="DSN">DSN</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item16" v-show="form.dentalOfficeManagmentSoftware.includes('DSN')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Eaglesoft">Eaglesoft</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item3" v-show="form.dentalOfficeManagmentSoftware.includes('Eaglesoft')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Easy Dental">Easy Dental</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item4" v-show="form.dentalOfficeManagmentSoftware.includes('Easy Dental')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Endo Vision">Endo Vision</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item14" v-show="form.dentalOfficeManagmentSoftware.includes('Endo Vision')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Fuse">Fuse</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item35" v-show="form.dentalOfficeManagmentSoftware.includes('Fuse')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="iDentalsoft">iDentalsoft</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item36" v-show="form.dentalOfficeManagmentSoftware.includes('iDentalsoft')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Mac Practice">Mac Practice</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item8" v-show="form.dentalOfficeManagmentSoftware.includes('Mac Practice')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="OMS Vision">OMS Vision</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item37" v-show="form.dentalOfficeManagmentSoftware.includes('OMS Vision')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Open Dental">Open Dental</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item6" v-show="form.dentalOfficeManagmentSoftware.includes('Open Dental')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Ortho Edge">Ortho Edge</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item38" v-show="form.dentalOfficeManagmentSoftware.includes('Ortho Edge')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Ortho Trac">Ortho Trac</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item39" v-show="form.dentalOfficeManagmentSoftware.includes('Ortho Trac')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Oryx">Oryx</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item46" v-show="form.dentalOfficeManagmentSoftware.includes('Oryx')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="PBS">PBS</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item25" v-show="form.dentalOfficeManagmentSoftware.includes('PBS')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Perio Vision">Perio Vision</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item40" v-show="form.dentalOfficeManagmentSoftware.includes('Perio Vision')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Practice Web">Practice Web</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item41" v-show="form.dentalOfficeManagmentSoftware.includes('Practice Web')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Practice Works">Practice Works</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item5" v-show="form.dentalOfficeManagmentSoftware.includes('Practice Works')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="QSI">QSI</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item24" v-show="form.dentalOfficeManagmentSoftware.includes('QSI')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Sensei Cloud">Sensei Cloud</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item42" v-show="form.dentalOfficeManagmentSoftware.includes('Sensei Cloud')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Softdent">Softdent</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item10" v-show="form.dentalOfficeManagmentSoftware.includes('Softdent')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Tab 32">Tab 32</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item43" v-show="form.dentalOfficeManagmentSoftware.includes('Tab 32')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="TDO">TDO</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item44" v-show="form.dentalOfficeManagmentSoftware.includes('TDO')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="TOPS">Tops</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item19" v-show="form.dentalOfficeManagmentSoftware.includes('TOPS')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Wave Ortho">Wave Ortho</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item45" v-show="form.dentalOfficeManagmentSoftware.includes('Wave Ortho')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="WinOMS">WinOMS</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item15" v-show="form.dentalOfficeManagmentSoftware.includes('WinOMS')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="XLDent">XLDent</el-checkbox><el-radio-group :disabled="isAdmin" v-model="dentalList.item22" v-show="form.dentalOfficeManagmentSoftware.includes('XLDent')"><el-radio label="1 year">&lt;1 year</el-radio><el-radio label="1-3 year">1-3 year</el-radio><el-radio label="3+ year">3+ year</el-radio></el-radio-group>
                            <el-checkbox label="Other">Other
                                <el-input :disabled="isAdmin" v-show="form.dentalOfficeManagmentSoftware.includes('Other')" v-model="form.dentalOfficeManagmentSoftwareOther"></el-input>
                            </el-checkbox>
                            <el-radio-group :disabled="isAdmin" v-model="dentalList.item29" v-show="form.dentalOfficeManagmentSoftware.includes('Other')">
                                <el-radio label="1 year">&lt;1 year</el-radio>
                                <el-radio label="1-3 year">1-3 year</el-radio>
                                <el-radio label="3+ year">3+ year</el-radio>
                            </el-radio-group>
                        </el-checkbox-group>
                    </el-form-item><br>
                    <el-form-item prop="mostProficientSoftware" label="What is your most proficient dental office management software?">
                        <el-radio-group :disabled="isAdmin" class="specail" ref="mostProficientSoftware" v-model="form.mostProficientSoftware">
                            <el-radio label="Archy">Archy</el-radio><br>
                            <el-radio label="Carestack">Carestack</el-radio><br>
                            <el-radio label="Cloud9">Cloud9</el-radio><br>
                            <el-radio label="Curve">Curve</el-radio><br>
                            <el-radio label="Denticon/Planet DDS">Denticon</el-radio><br>
                            <el-radio label="Dentimax">Dentimax</el-radio><br>
                            <el-radio label="Dentrix">Dentrix</el-radio><br>
                            <el-radio label="Ascend">Dentrix Ascend</el-radio><br>
                            <el-radio label="Enterprise">Dentrix Enterprise</el-radio><br>
                            <el-radio label="Dolphin">Dolphin</el-radio><br>
                            <el-radio label="DOX">DOX</el-radio><br>
                            <el-radio label="DSN">DSN</el-radio><br>
                            <el-radio label="Eaglesoft">Eaglesoft</el-radio><br>
                            <el-radio label="Easy Dental">Easy Dental</el-radio><br>
                            <el-radio label="Endo Vision">Endo Vision</el-radio><br>
                            <el-radio label="Fuse">Fuse</el-radio><br>
                            <el-radio label="iDentalsoft">iDentalsoft</el-radio><br>
                            <el-radio label="Mac Practice">Mac Practice</el-radio><br>
                            <el-radio label="OMS Vision">OMS Vision</el-radio><br>
                            <el-radio label="Open Dental">Open Dental</el-radio><br>
                            <el-radio label="Ortho Edge">Ortho Edge</el-radio><br>
                            <el-radio label="Ortho Trac">Ortho Trac</el-radio><br>
                            <el-radio label="Oryx">Oryx</el-radio><br>
                            <el-radio label="PBS">PBS</el-radio><br>
                            <el-radio label="Perio Vision">Perio Vision</el-radio><br>
                            <el-radio label="Practice Web">Practice Web</el-radio><br>
                            <el-radio label="Practice Works">Practice Works</el-radio><br>
                            <el-radio label="QSI">QSI</el-radio><br>
                            <el-radio label="Sensei Cloud">Sensei Cloud</el-radio><br>
                            <el-radio label="Softdent">Softdent</el-radio><br>
                            <el-radio label="Tab 32">Tab 32</el-radio><br>
                            <el-radio label="TDO">TDO</el-radio><br>
                            <el-radio label="TOPS">Tops</el-radio><br>
                            <el-radio label="Wave Ortho">Wave Ortho</el-radio><br>
                            <el-radio label="WinOMS">WinOMS</el-radio><br>
                            <el-radio label="XLDent">XLDent</el-radio><br>
                            <el-radio label="Other">Other&nbsp;&nbsp;
                                <el-input :disabled="isAdmin" style="width:100px;" v-show="form.mostProficientSoftware == 'Other'" size="mini" v-model="form.mostProficientSoftwareOther"></el-input>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item><br>
                    <el-form-item v-if="form.IsInterestedLearnPracticeSoftware==true" prop="IsWillingPayToTeach" label="Would you be willing to pay a third party consultant to teach you?">
                        <el-select :disabled="isAdmin" placeholder="" ref="IsWillingPayToTeach" v-model="form.IsWillingPayToTeach" style="width:300px;">
                            <el-option label="None" value=""></el-option>
                            <el-option label="Yes" :value="true"></el-option>
                            <el-option label="No" :value="false"></el-option>
                        </el-select>
                    </el-form-item><br>
                    <el-form-item prop="dentalSpecialties" label="What Dental Specialties have you billed for? ">
                        <el-checkbox-group :disabled="isAdmin" class="specail" ref="dentalSpecialties"
                                           v-model="form.dentalSpecialties" @change="changeSpecial($event)">
                            <el-checkbox label="Orthodontics">Orthodontics</el-checkbox>
                            <el-checkbox label="Oral Surgery">Oral Surgery</el-checkbox>
                            <el-checkbox label="Periodontal">Periodontal</el-checkbox>
                           
                            <el-checkbox label="Pedodontics">Pedodontics</el-checkbox>
                            <el-checkbox label="Prosthodontics">Prosthodontics</el-checkbox>
                            <el-checkbox label="General Practice">General Practice</el-checkbox>
                            <el-checkbox label="None">None</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item><br>
                    <el-form-item prop="haveExperienceWith" label="Do you have experience with:">
                        <el-checkbox-group :disabled="isAdmin" class="specail" ref="haveExperienceWith" v-model="form.haveExperienceWith" @change="changeExperience($event)">
                            <el-checkbox label="Bookkeeping experience" :disabled="form.haveExperienceWith.indexOf('None of the above')>=0">Bookkeeping experience</el-checkbox>
                            <el-checkbox label="Dental Accounting using QuickBooks" :disabled="form.haveExperienceWith.indexOf('None of the above')>=0">Dental Accounting using QuickBooks</el-checkbox>
                            <el-checkbox label="QuickBooks Certifield" :disabled="form.haveExperienceWith.indexOf('None of the above')>=0">QuickBooks Certifield</el-checkbox>
                            <el-checkbox label="Medical Billing" :disabled="form.haveExperienceWith.indexOf('None of the above')>=0">Medical Billing</el-checkbox>
                            <el-checkbox label="Billing DMO" :disabled="form.haveExperienceWith.indexOf('None of the above')>=0">DSO</el-checkbox>
                            <el-checkbox label="None of the above">None</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item><br>
                    <el-form-item prop="medicaidExperience" label="Do you have experience in Medicaid?">
                        <el-checkbox-group @change="changeMedicaidExperience" :disabled="isAdmin" class="specail" ref="medicaidExperience" v-model="form.medicaidExperience">
                            <el-checkbox label="Denti-Cal" :disabled="form.medicaidExperience.indexOf('None')>=0">Denti-Cal</el-checkbox>
                            <el-checkbox label="Other Medicaid Plans" :disabled="form.medicaidExperience.indexOf('None')>=0">Other Medicaid Plans
                                <el-input :disabled="isAdmin" v-show="form.medicaidExperience.includes('Other Medicaid Plans')" v-model="form.medicaidExperienceOther"></el-input>
                            </el-checkbox>
                            <el-checkbox label="None">None</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item><br>
                    <el-form-item prop="education" label='Please describe your formal educational experiences.'>
                        <el-checkbox-group @change="changeEducation" :disabled="isAdmin" class="specail" ref="education" v-model="form.education">
                            <el-checkbox label="Some college" :disabled="form.education.indexOf('None')>=0">Some college</el-checkbox>
                            <el-checkbox label="College degree" :disabled="form.education.indexOf('None')>=0">College degree</el-checkbox>
                            <el-checkbox label="Graduate degree" :disabled="form.education.indexOf('None')>=0">Graduate degree</el-checkbox>
                            <el-checkbox label="Vocational vetting" :disabled="form.education.indexOf('None')>=0">Vocational certification</el-checkbox>
                            <el-checkbox label="None">None</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item><br>
                    <el-form-item prop="frontOfficeSkillSet" label="Dental Front Office Skill Set (Please select all that apply)">
                        <el-checkbox-group @change="changeFrontOfficeSkillSet" :disabled="isAdmin" class="specail" ref="frontOfficeSkillSet" v-model="form.frontOfficeSkillSet">
                            <el-checkbox label="I understand how to read ledgers">I understand how to read ledgers</el-checkbox>
                            <el-checkbox label="I know how to post EOBs and all adjustments on patient accounts">I know how to post EOBs and all adjustments on patient accounts</el-checkbox>
                            <el-checkbox label="I am competent at getting insurance companies to pay claims that are denied">I am competent at getting insurance companies to pay claims that are denied</el-checkbox>
                            <el-checkbox label="I know how to work an aging report">I know how to work an aging report</el-checkbox>
                            <el-checkbox label="I know how to send electronic claims">I know how to send electronic claims</el-checkbox>
                            <el-checkbox label="I know how to send electronic attachments">I know how to send electronic attachments</el-checkbox>
                            <el-checkbox label="None">None</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item><br>
                    <el-form-item prop="typingSpeed" label="How fast can you type? ">
                        <el-select :disabled="isAdmin" placeholder="" ref="typingSpeed" v-model="form.typingSpeed" style="width:300px;">
                            <el-option
                                v-for="item in options1"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item><br>
                    <el-form-item prop="computerSkillLevel" label="How would you rate your computer skill level? (Please select all that apply)">
                        <el-checkbox-group :disabled="isAdmin" class="specail" ref="computerSkillLevel" v-model="form.computerSkillLevel">
                            <el-checkbox label="I can build or fix a PC">I can build or fix a computer</el-checkbox>
                            <el-checkbox label="I help others with computer problems">I help others with computer problems</el-checkbox>
                            <el-checkbox label="My PCs often get infected with viruses">My computer is often infected with viruses</el-checkbox>
                            <el-checkbox label="I am able to clean a virus off a PC">I am able to clean a virus off a computer</el-checkbox>
                            <el-checkbox label="I get others to help me with my PC from time to time">I get others to help me with
                                my computer from time to time</el-checkbox>
                            <el-checkbox label="I am proficient in MS Office (word, excel, etc)">I am proficient in Google Workspace</el-checkbox>
                            <el-checkbox label="I don't own a computer">I don't own a computer</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item><br>
                    <el-form-item prop="IsWorkedForEAsssitClient" label="Do you currently work or have you worked for a dental office that uses the eAssist platform or that did in the past?">                                  
                        <div style="color: gray;margin-bottom: 10px;font-weight: 700;line-height: normal;">
                            Reminder: failure to properly disclose or provide accurate responses, or intentionally misstating anything, on your application, may result in termination of your application or employment with eAssist.
                        </div>
                        <el-select :disabled="isAdmin" placeholder="" ref="IsWorkedForEAsssitClient" v-model="form.IsWorkedForEAsssitClient">
                            <el-option label="Yes" :value="true"></el-option>
                            <el-option label="No" :value="false"></el-option>
                        </el-select>
                        <el-input  ref="haveWorkedOffice" :disabled="isAdmin" style="width:276px;margin-left: 10px"
                                   placeholder="Office Name"
                                   v-show="form.IsWorkedForEAsssitClient==true"
                                   v-model="form.haveWorkedOffice"></el-input>
                    </el-form-item>
                    <br>
                    <el-form-item prop="isEmployed" label="Are you currently employed or providing services?">
                        <el-select :disabled="isAdmin" placeholder="" ref="isEmployed" v-model="form.isEmployed">
                            <el-option label="Yes" :value="true"></el-option>
                            <el-option label="No" :value="false"></el-option>
                        </el-select>
                    </el-form-item><br>
                    <el-form-item prop="whenWork" label="Why are you applying to eAssist? (select all that apply)">
                        <el-checkbox-group :disabled="isAdmin" class="specail" ref="whenWork" v-model="form.whenWork">
                            <el-checkbox label="Remote Full Time Position">Remote Full Time Position</el-checkbox>
                            <el-checkbox label="Part Time Work from Home">Part Time Work from Home</el-checkbox>
                            <el-checkbox label="Flexible Hours">Flexible Hours</el-checkbox>
                            <el-checkbox label="Commission Based Compensation">Commission Based Compensation</el-checkbox>
                            <el-checkbox label="Other">Other
                                <el-input :disabled="isAdmin" v-show="form.whenWork.indexOf('Other')>=0" v-model="form.whenWorkOther"></el-input>
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item prop="whatInterested" label="We love that you're interested in our company! Please let us know what positions you are interested in. (select all that apply)">
                        <el-checkbox-group :disabled="isAdmin" class="specail" ref="whatInterested" v-model="form.whatInterested">
                            <el-checkbox label="Dental Billing (Posting, Aging, Claim Submission)">Dental Billing (Posting, Aging, Claim Submission)</el-checkbox>
                            <el-checkbox label="Patient Billing">Patient Billing</el-checkbox>
                            <el-checkbox label="Insurance Verification">Insurance Verification</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item><br>
                    <hr style="margin:30px 0;">
                    <div class="pageSectionTitle">INTERNET BROADBAND SPECIFICS</div>
                    <el-form-item prop="internetServiceProvider" label="Who is your internet service provider?">
                        <el-input :disabled="isAdmin" ref="internetServiceProvider" v-model="form.internetServiceProvider" style="width:350px;"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="typeOfInternetConnection" label="Type of internet connection?">
                        <el-select :disabled="isAdmin" placeholder="" ref="typeOfInternetConnection" v-model="form.typeOfInternetConnection" style="width:350px;">
                            <el-option label="None" value=""></el-option>
                            <el-option label="Cable" value="Cable"></el-option>
                            <el-option label="DSL" value="DSL"></el-option>
                            <el-option label="Fiber" value="Fiber"></el-option>
                            <el-option label="Wireless" value="Wireless"></el-option>
                            <el-option label="Other" value="Other"></el-option>
                        </el-select>
                    </el-form-item><br>
                    <div style="font-size: 14px;color:rgb(129, 135, 137);margin-bottom:15px;">click <a target="_blank" href="https://speedtest.net">here</a> to run an internet speed test.<br/>Once your speed test has completed please take a screen shot of your test and upload it in the provided area.</div>
                    <el-form-item label="Upload the screen shot" prop="uploadScreenShotUrl" v-if="!isAdmin">
                        <el-upload
                            ref="uploadScreenShotUrl"
                            class="upload-demo"
                            :action="this.$URL.uploadUrl"
                            :data="{baseDir:'Applicant/Apply'}"
                            :on-success="uploadSuccess1"
                            :show-file-list="false"
                            accept=".jpg,.png,.bmp,.jpeg,.webp,.JPG,.PNG,.BMP,.JPEG,.WEBP,.Jpg,.Png,.Bmp,.Jpeg,.Webp">
                            <el-button style="background:#2EC4E3;border:1px solid #2EC4E3;font-weight:700;" type="primary" v-show="!isAdmin&&!form.uploadScreenShotUrl">+ Add Files</el-button>
                            <span style="font-weight:700;font-size:22px;margin-left:30px" v-show="form.uploadScreenShotUrl">{{formateUrl(form.uploadScreenShotUrl)}}</span>
                            <span @click="edit1" style="font-weight:700;color:#C2C2C6;font-size:19px;margin-left:20px;cursor:pointer;" v-show="form.uploadScreenShotUrl&&!isAdmin">Edit</span>
                            <span @click="remove1" style="font-weight:700;color:#C2C2C6;font-size:19px;margin-left:10px;cursor:pointer;" v-show="form.uploadScreenShotUrl&&!isAdmin">Remove</span>
                        </el-upload>
                    </el-form-item>
                    <el-form-item v-if="(isAdmin||model)&&form.uploadScreenShotUrl">
                        <el-image style="width: 800px" :src="form.uploadScreenShotUrl"></el-image>
                    </el-form-item>
                    <hr style="margin:30px 0;">
                    <div class="pageSectionTitle">EDUCATION, HONORS, & REFERENCES</div>
                    <el-form-item style="width:99%" label="Describe any specialized vetting, apprenticeships, licenses or skills" prop="specializedTraining">
                        <el-input :disabled="isAdmin" ref="specializedTraining" v-model="form.specializedTraining" rows="5" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item prop="allDentalOfficeEmployment" label="Please describe your last three dental office experiences (if any) and your current employment status at each.">
                        <el-input :disabled="isAdmin" ref="allDentalOfficeEmployment" v-model="form.allDentalOfficeEmployment" rows="5" type="textarea"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="referenceList" label="List 3 professional references (Please include names, email addresses, phone numbers, relationship / occupation, and years known.)">
                        <el-row :gutter="20" style="color:#2EC4E4;text-align:center;font-weight:700;">
                            <el-col :span="4">NAME</el-col>
                            <el-col :span="7">EMAIL ADDRESS</el-col>
                            <el-col :span="4">PHONE NUMBER</el-col>
                            <el-col :span="3">OCCUPATION</el-col>
                            <el-col :span="4">YEARS</el-col>
                        </el-row>
                        <el-row v-for="(item, index) in form.referenceList" :key="index" :gutter="20" style="margin-bottom:20px;">
                            <el-col :span="4">
                                <el-input :disabled="isAdmin" v-model="item.name"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-input :disabled="isAdmin" v-model="item.address"></el-input>
                            </el-col>
                            <el-col :span="4">
                                <el-input :disabled="isAdmin" v-model="item.phone"></el-input>
                            </el-col>
                            <el-col :span="3">
                                <el-input :disabled="isAdmin" v-model="item.occupation"></el-input>
                            </el-col>
                            <el-col :span="4">
                                <el-input :disabled="isAdmin" v-model="item.year"></el-input>
                            </el-col>
                            <el-col :span="1" v-show="index>=3">
                                <el-button :disabled="isAdmin" type="danger" @click="del(index)">Delete</el-button>
                            </el-col>
                        </el-row>
                        <el-button style="background:#2EC4E3;border:1px solid #2EC4E3;font-weight:700;color:#fff;" @click="addItem" v-show="!isAdmin">+Add</el-button>
                        <div ref="form.referenceList"></div>
                    </el-form-item>
                </el-form>
                <hr style="margin:30px 0;">
                <div style="font-weight:700;margin:10px 0;">
                    Electronic Signature *
                </div>
                <div style="font-size:14px;color:#818789">
                   <p>***PLEASE READ CAREFULLY BEFORE SIGNING***</p><br/>
APPLICANT ACKNOWLEDGMENT AND AUTHORIZATION <br/><br/>
I hereby certify that all of the information provided by me in this application (including any accompanying or required documents) is correct, accurate and complete. I understand that the falsification, misrepresentation or omission of any information or facts in said documents will be cause for denial of my application or immediate termination of any engagement I may have with eAssist, Inc. (“eAssist”) regardless of the timing or circumstances of discovery. I understand that submission of any application does not guarantee that I will be hired by eAssist or otherwise engaged. I understand that, as a condition to being hired by eAssist, I will be required to submit to a pre-hire background check and drug screening. I understand that failure to cooperate with any of the foregoing will result in a rejection of my application or termination of my association with eAssist. I hereby authorize all schools, former employers, references, courts and any others who have information about me to provide such information to eAssist and/or any of its representatives, agenda or vendors.
<br/><br/>By typing my name below, I acknowledge and agree to all of the terms and conditions of the foregoing application, and will be deemed to have signed this application electronically, effective on the date I type my name pursuant to all applicable laws.  Doing so constitutes an acknowledgement that I agree to conduct the transaction electronically, and am able to electronically receive, download and print this application and related agreements.  I agree that my electronic or digital signature will be valid and binding and considered as an original signature.
                <br/><br/>
                </div>
                <el-input :disabled="isAdmin" ref="signature" v-model="form.signature" style="width:400px;" placeholder="Type your name here"></el-input>
                <div style="height:25px">
                    <div v-show="signFail" style="height:20px;color:red;">Your signature does not match the name you registered this account under. Please sign as {{this.form.firstName+' '+this.form.lastName}} to continue.</div>
                </div>
                <div style="margin-bottom:10px;">
                    <el-checkbox :disabled="isAdmin" @change="changeAccept" ref="isAccepted" v-model="form.isAccepted">By marking the box, I consent to eAssist (a) recording all audio and/or video interviews or discussions I may have with eAssist personnel, and (b) using the same in conducting its business.</el-checkbox>
                </div>
                <div style="height:25px">
                    <div v-show="acceptFail" style="height:20px;color:red;">Please Accept Terms and Conditions</div>
                </div>
                <div style="margin-bottom:10px;">
                    <el-date-picker ref="available" :disabled="isAdmin" v-model="form.available" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd 00:00:00" placeholder="Date" style="width:220px;"></el-date-picker>
                </div>
                <div style="height:25px">
                    <div v-show="consentFail" style="height:20px;color:red;">Date Required</div>
                </div>
                <el-button @click="editApply" class="yellowBtn" v-show="isAdmin">Edit </el-button>
                <el-button @click="submit" class="yellowBtn" v-show="!isAdmin">NEXT ></el-button>
            </section>
        </div>
    </div>
</template>
<script>
import mask from 'vue-r-mask'
import Side from '@/components/Aside.vue'
import ApplyHeader from "@/components/ApplyHeader";
import moment from 'moment';
import { getCookie,chat2Ascii,hasLogin } from "../../../static/js/util.js";
function setSubmitValue(val1, val2) {
    var valueList = "";
    val1.forEach(n => {
        valueList += '|' + n
    })

    if (val2 && val2.length > 0)
        valueList = valueList + "|" + val2

    return valueList;
}
function setSubmitValue1(val1, val2) {
    // console.log(val1)
    var valueList1 = "";
    if(val1.includes('Archy')){
        valueList1 += '|Archy' + '[' + val2.item30 + ']'
    }
    if(val1.includes('Carestack')){
        valueList1 += '|Carestack' + '[' + val2.item31 + ']'
    }
    if(val1.includes('Cloud9')){
        valueList1 += '|Cloud9' + '[' + val2.item32 + ']'
    }
    if(val1.includes('Dolphin')){
        valueList1 += '|Dolphin' + '[' + val2.item33 + ']'
    }
    if(val1.includes('DOX')){
        valueList1 += '|DOX' + '[' + val2.item34 + ']'
    }
    if(val1.includes('Fuse')){
        valueList1 += '|Fuse' + '[' + val2.item35 + ']'
    }
    if(val1.includes('iDentalsoft')){
        valueList1 += '|iDentalsoft' + '[' + val2.item36 + ']'
    }
    if(val1.includes('OMS Vision')){
        valueList1 += '|OMS Vision' + '[' + val2.item37 + ']'
    }
    if(val1.includes('Ortho Edge')){
        valueList1 += '|Ortho Edge' + '[' + val2.item38 + ']'
    }
    if(val1.includes('Ortho Trac')){
        valueList1 += '|Ortho Trac' + '[' + val2.item39 + ']'
    }
    if(val1.includes('Oryx')){
        valueList1 += '|Oryx' + '[' + val2.item46 + ']'
    }
    if(val1.includes('Perio Vision')){
        valueList1 += '|Perio Vision' + '[' + val2.item40 + ']'
    }
    if(val1.includes('Practice Web')){
        valueList1 += '|Practice Web' + '[' + val2.item41 + ']'
    }
    if(val1.includes('Sensei Cloud')){
        valueList1 += '|Sensei Cloud' + '[' + val2.item42 + ']'
    }
    if(val1.includes('Tab 32')){
        valueList1 += '|Tab 32' + '[' + val2.item43 + ']'
    }
    if(val1.includes('TDO')){
        valueList1 += '|TDO' + '[' + val2.item44 + ']'
    }
    if(val1.includes('Wave Ortho')){
        valueList1 += '|Wave Ortho' + '[' + val2.item45 + ']'
    }
    if(val1.includes('Curve')){
        valueList1 += '|Curve' + '[' + val2.item1 + ']'
    }
    if(val1.includes('Dentrix')){
        valueList1 += '|Dentrix' + '[' + val2.item2 + ']'
    }
    if(val1.includes('Eaglesoft')){
        valueList1 += '|Eaglesoft' + '[' + val2.item3 + ']'
    }
    if(val1.includes('Easy Dental')){
        valueList1 += '|Easy Dental' + '[' + val2.item4 + ']'
    }
    if(val1.includes('Practice Works')){
        valueList1 += '|Practice Works' + '[' + val2.item5 + ']'
    }
    if(val1.includes('Open Dental')){
        valueList1 += '|Open Dental' + '[' + val2.item6 + ']'
    }
    if(val1.includes('Mac Practice')){
        valueList1 += '|Mac Practice' + '[' + val2.item8 + ']'
    }
    if(val1.includes('Dentimax')){
        valueList1 += '|Dentimax' + '[' + val2.item9 + ']'
    }
    if(val1.includes('Softdent')){
        valueList1 += '|Softdent' + '[' + val2.item10 + ']'
    }
    if(val1.includes('Enterprise')){
        valueList1 += '|Enterprise' + '[' + val2.item11 + ']'
    }
    if(val1.includes('Ascend')){
        valueList1 += '|Ascend' + '[' + val2.item12 + ']'
    }
    if(val1.includes('Endo Vision')){
        valueList1 += '|Endo Vision' + '[' + val2.item14 + ']'
    }
    if(val1.includes('WinOMS')){
        valueList1 += '|WinOMS' + '[' + val2.item15 + ']'
    }
    if(val1.includes('DSN')){
        valueList1 += '|DSN' + '[' + val2.item16 + ']'
    }
    if(val1.includes('TOPS')){
        valueList1 += '|TOPS' + '[' + val2.item19 + ']'
    }
    if(val1.includes('Denticon/Planet DDS')){
        valueList1 += '|Denticon/Planet DDS' + '[' + val2.item20 + ']'
    }
    if(val1.includes('XLDent')){
        valueList1 += '|XLDent' + '[' + val2.item22 + ']'
    }
    if(val1.includes('QSI')){
        valueList1 += '|QSI' + '[' + val2.item24 + ']'
    }
    if(val1.includes('PBS')){
        valueList1 += '|PBS' + '[' + val2.item25 + ']'
    }
    if(val1.includes('Other')){
        valueList1 += '|Other' + '[' + val2.item29 + ']'
    }
    return valueList1;
}
export default {
    components:{
        Side:Side,
        ApplyHeader
    },
    data() {
        function isEmail (s) {
            return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(s)
        }
        let validateEmail = (rule, value, callback) => {
            if (!isEmail(value)) {
                callback(new Error('The Email field is not a valid e-mail address'))
            } else {
                callback()
            }
        }
        let validatePass = (rule, value, callback) => {
            console.log('检测222')
            if (value === '') {
                callback(new Error('Required'));
            } else if (value !== this.form.password) {
                callback(new Error('Your password and the confirmed password do not match!'));
            } else {
                callback();
            }
        };
        let validateList =  (rule, value, callback) => {
            var count = 0
            this.form.referenceList.forEach(n => {
                if(n.name && n.address && n.phone && n.occupation){
                    count++
                }
            })
            if (count>=3) {
                callback()
            } else {
                callback(new Error('Required'))
            }
        };
        let validateHaveWorkedOffice = (rule,value,callback)=>{
            if(this.form.haveWorkedOffice===''&&value){
                callback(new Error('Required'))
            }else{
                callback()
            }
        };
        //验证mostProficienSoftWare值如果是other还要继续进行验证
        let validateMostProficienSoftWare = (rule,value,callback)=>{
            let mostProficientSoftwareOther = this.form.mostProficientSoftwareOther
            if(!value||value=='Other'&&mostProficientSoftwareOther==''){
                callback(new Error('Required'))
            }else{
                callback()
            }
        };
        //验证dentalOfficeManagmentSoftware值如果选择包含other还要继续进行验证
        let validateDentalOfficeManagmentSoftware =  (rule,value,callback)=>{
            let dentalOfficeManagmentSoftwareOther = this.form.dentalOfficeManagmentSoftwareOther
            if(value.length==0||value.indexOf('Other')>=0&&dentalOfficeManagmentSoftwareOther==''){
                callback(new Error('Required'))
            }else{
                callback()
            }
        };
        let validateEducation = (rule,value,callback)=>{
            let educationOther = this.form.educationOther
            if(value.length==0||value.indexOf('Other')>=0&&educationOther==''){
                callback(new Error('Required'))
            }else{
                callback()
            }
        };
        let validateIsApplied = (rule,value,callback)=>{
            let isApplied = this.form.isApplied
            let applyPreviousName = this.form.applyPreviousName
            let appliedDate = this.form.previousApplication
            if(isApplied==true&&appliedDate==null){
                callback(new Error('Applied Date required'))
            }else if(isApplied==true&&applyPreviousName==''){
                callback(new Error('Previous Name Used to Apply required'))
            }else{
                callback()
            }
        }
        let validateFamilyAteAssist = (rule,value,callback)=>{
            let familyAteAssist = this.form.familyAteAssist
            if(familyAteAssist==true&&this.form.familyAteAssistName==''){
                callback(new Error('Name & Relation required'))
            }else{
                callback()
            }
        }
        let validateHowLearned = (rule,value,callback)=>{
            let howLearned = this.form.howLearned
            if(howLearned==5&&this.form.howLearnedOther==''){
                callback(new Error('Other Content required'))
            }else{
                callback()
            }
        }
        let validateMedicaidExperience = (rule,value,callback)=>{
            let medicaidExperienceOther = this.form.medicaidExperienceOther
            if(value.indexOf('Other Medicaid Plans')>=0&&medicaidExperienceOther==''){
                callback(new Error('Required'))
            }else{
                callback()
            }
        }
        let validatorLanguages = (rule,value,callback)=>{
            let languagesOther = this.form.languagesOther
            if(value.indexOf('Other')>=0&&languagesOther==''){
                callback(new Error('Required'))
            }else{
                callback()
            }
        }
        let validateWhenWork = (rule,value,callback)=>{
            let whenWorkOther = this.form.whenWorkOther
            if(value.indexOf('Other')>=0&&whenWorkOther==''){
                callback(new Error('Required'))
            }else{
                callback()
            }
        }
        return {
            disableCityAndState:true,
            applicantID:-1,
            reviewModel:false,
            isAdmin:false,
            loading:false,
            phone:'',
            origin:'',
            signFail:false,
            acceptFail:false,
            consentFail:false,
            options1:[
                {value:'<30 words per minute',label:'<30 words per minute'},
                {value:'31-45 words per minute',label:'31-45 words per minute'},
                {value:'46-60 words per minute',label:'46-60 words per minute'},
                {value:'60-75 words per minute',label:'60-75 words per minute'},
                {value:'>75 words per minute',label:'>75 words per minute'}
            ],
            dentalList:{
                item1:'',
                item2:'',
                item3:'',
                item4:'',
                item5:'',
                item6:'',
                item7:'',
                item8:'',
                item9:'',
                item10:'',
                item11:'',
                item12:'',
                item13:'',
                item14:'',
                item15:'',
                item16:'',
                item17:'',
                item18:'',
                item19:'',
                item20:'',
                item21:'',
                item22:'',
                item23:'',
                item24:'',
                item25:'',
                item26:'',
                item27:'',
                item28:'',
                item29:'',
                item30:'',
                item31:'',
                item32:'',
                item33:'',
                item34:'',
                item35:'',
                item36:'',
                item37:'',
                item38:'',
                item39:'',
                item40:'',
                item41:'',
                item42:'',
                item43:'',
                item44:'',
                item45:'',
                item46:'',
            },
            form:{
                firstName:'',
                middleName:'',
                lastName:'',
                preferredName:'',
                email:'',
                password:'',
                password2:'',
                phone:'',
                address:'',
                city:'',
                state:'',
                zipCode:'',
                country:'',
                applyPosition:'',
                expectedSalary:'',
                available:null,
                yearsDentalExperience:0,
                yearsFrontOfficeExperience:0,
                languages:[],
                languagesOther:'',
                typingSpeed:'',
                isApplied:false,
                previousApplication:'',
                ableToWorkInUS:false,
                over18:false,
                haveWorkedOffice:'',
                felony:'',
                familyAteAssist:'',
                familyAteAssistName:'',
                applyPreviousName:'',
                howLearned:0,
                howLearnedOther:'',
                howLearnedOther1:'',
                expectedHours:'',
                medicaidExperience:[],
                medicaidExperienceOther:'',
                dentalOfficeManagmentSoftware:[],
                dentalOfficeManagmentSoftwareOther:'',
                mostProficientSoftware:'',
                mostProficientSoftwareOther:'',
                currentlyOnPracticeSoftware:'',
                currentlyOnPracticeSoftwareOther:'',
                dentalSpecialties:[],
                haveExperienceWith:[],
                browser:'',
                isUsingPC:'',
                education:[],
                educationOther:'',
                frontOfficeSkillSet:[],
                computerSkillLevel:[],
                isEmployed: '',
                IsWorkedForEAsssitClient:'',
                whenWork:[],
                whenWorkOther:'',
                whatInterested:[],
                internetServiceProvider:'',
                typeOfInternetConnection:'',
                pingResults:'',
                downloadSpeed:'',
                uploadSpeed:'',
                academicHonors:'',
                specializedTraining:'',
                allDentalOfficeEmployment:'',
                checkReferenceList:'',
                IsInterestedLearnPracticeSoftware:'',
                IsWillingPayToTeach:'',
                referenceList:[
                    {name:'',address:'',phone:'',occupation:'',year:''},
                    {name:'',address:'',phone:'',occupation:'',year:''},
                    {name:'',address:'',phone:'',occupation:'',year:''}
                ],
                signature:'',
                isAccepted:false,
                uploadScreenShotUrl:'',
                resumeUrl:'',
                haveWorked:false,
                version: 5
            },
            rules1:{
                isEmployed:[
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                specializedTraining: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                firstName: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                //2025-3-13改为不必填
                // middleName: [
                //     { required: true, message: 'Required', trigger: 'blur' },
                // ],
                lastName: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: 'Required', trigger: 'blur' },
                    { validator: validateEmail, trigger: 'blur' }
                ],
                password: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                password2: [
                    { required: true, message: 'Required', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: 'Required', trigger: 'change' },
                ],
                address: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                city: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                state: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                country: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                zipCode: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                //这里需要验证YES的时候 输入框内容是否为空
                isApplied: [
                    { required: true, message: 'Required', trigger: 'blur' },
                    {
                        validator:validateIsApplied,
                        trigger: 'blur'
                    }
                ],
                medicaidExperience:[
                    { required: true, message: 'Required', trigger: 'blur' },
                    { validator:validateMedicaidExperience,trigger: 'blur'}
                ],
                // haveWorkedOffice: [
                //     { validator: validateHaveWorkedOffice }
                // ],
                IsWorkedForEAsssitClient:[
                    {required:true,message:'Required',trigger:'blur'},
                    { validator: validateHaveWorkedOffice }],
                yearsDentalExperience: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                languages: [
                    { required: true, message: 'Required', trigger: 'blur' },
                    { validator:validatorLanguages,trigger: 'blur'}
                ],
                yearsFrontOfficeExperience: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                typingSpeed: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                familyAteAssist: [
                    { required: true, message: 'Required', trigger: 'blur' },
                    {validator:validateFamilyAteAssist,trigger: 'blur'}
                ],
                howLearned: [
                    { required: true, message: 'Required', trigger: 'blur' },
                    {validator:validateHowLearned,trigger: 'blur'}
                ],
                expectedHours: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                dentalOfficeManagmentSoftware: [
                    {required: true, message: 'Required', trigger: 'blur'},
                    { validator:validateDentalOfficeManagmentSoftware, trigger: 'blur' },
                ],
                mostProficientSoftware: [
                     {required:true,validator:validateMostProficienSoftWare,trigger: 'blur' },
                ],
                dentalSpecialties: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                haveExperienceWith: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                education: [
                    { required: true, message: 'Required', trigger: 'blur' }
                ],
                frontOfficeSkillSet: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                computerSkillLevel: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                internetServiceProvider: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                typeOfInternetConnection: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                haveWorked: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                whenWork: [
                    //{ required: true, message: 'Required', trigger: 'blur' },
                    {validator:validateWhenWork,trigger: 'blur'}
                ],
                whatInterested : [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                allDentalOfficeEmployment: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                resumeUrl: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                uploadScreenShotUrl: [
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                //新增加的
                IsWillingPayToTeach:[
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                IsInterestedLearnPracticeSoftware:[
                    { required: true, message: 'Required', trigger: 'blur' },
                ],
                referenceList: [
                    {required:true, validator: validateList }
                ]
            }
        }
    },
    computed:{
        model(){
            return this.$route.query.model&&this.$route.query.model=='review'
        },
        OfficeName(){
            var res = this.form.IsWorkedForEAsssitClient==true
            console.log('officename',res)
            return res
        },
        formateUrl(){
            return function(url) {
                if(url&&url.indexOf('/')>=0){
                    return url.split('/')[url.split('/').length-1]
                }else return url
            }
        },
        hasLogin
    },
    methods:{
        changeFrontOfficeSkillSet(val){
            let index = val.indexOf('None')
            if(index>=0){
                if(val.length-1==index)this.form.frontOfficeSkillSet=['None']
                else this.form.frontOfficeSkillSet.splice(index,1)
            }
        },
        changeEducation(val){
            if(val.indexOf('None')>=0){
                this.form.education=['None']
            }
        },
        changeMedicaidExperience(val){
            if(val.indexOf('None')>=0){
                this.form.medicaidExperience=['None']
            }
        },
        //把city和state变为可输入
        enableCityState(){
            this.disableCityAndState = false
        },
        changeExperience(value){
            if(value.indexOf('None of the above')>0){
                this.form.haveExperienceWith=['None of the above']
            }
        },
        changeSpecial(value){
            let len = value.length
            let noneIndex = value.indexOf('None')
            if(noneIndex>=0){
                if(noneIndex==len-1)this.form.dentalSpecialties=['None']
                else this.form.dentalSpecialties.splice(noneIndex,1)
            }
            // if(value.indexOf('General Practice')>0){
            //     this.form.dentalSpecialties=['General Practice']
            // }
        },
        downloadFile(url){
            if(!this.isAdmin||!url)return
            window.open(url);
        },
        hasOtherInArray(datas,keys=[]){
            let res = {hasFill:false,item:null}
            datas.forEach(item=>{
                if(keys.indexOf(item)<0){
                    res.hasFill = true
                    res.item = item
                }
            })
            return res;
        },
        deconstructData(data){
            this.form.firstName=data.firstName
            this.form.middleName = data.middleName
            this.form.lastName = data.lastName
            this.form.preferredName = data.preferredName||''
            this.form.email = data.email
            this.form.password = data.password
            this.form.password2 = data.password2
            this.form.phone = data.phone//有问题
            this.phone = data.phone
            this.form.address = data.address
            this.form.city = data.city
            this.form.state = data.state
            this.form.zipCode = data.zipCode
            this.form.country = data.country
            this.form.expectedSalary = data.expectedSalary
            this.form.available= data.available
            this.form.yearsDentalExperience= data.yearsDentalExperience
            this.form.yearsFrontOfficeExperience = data.yearsFrontOfficeExperience
            //这里由于languages是['chinese','english','Other:xxx']模式，所以需要解析
            let languages = data.languages.split('|')
            let languageArr= [] 
            for(let i = 0;i<languages.length;i++){
                if(languages[i].indexOf('Other')>=0){
                    this.form.languagesOther = languages[i].split(':')[1]
                    languageArr.push('Other')
                }else{
                    languageArr.push(languages[i])
                }
            }
            this.form.languages= languageArr
            this.form.typingSpeed = data.typingSpeed
            this.form.isApplied = data.isApplied
            this.form.previousApplication = data.previousApplication
            this.form.ableToWorkInUS = data.ableToWorkInUS
            this.form.over18 = data.over18
            this.form.felony = data.felony
            if(data.familyAteAssist==''){
                this.form.familyAteAssist = false
                this.form.familyAteAssistName = ''
            }else {
                this.form.familyAteAssist = true
                this.form.familyAteAssistName = data.familyAteAssist
            }
            let applyPreviousName = data.applyPreviousName||''
            if(applyPreviousName==''){
                this.form.isApplied = false
            }else{
                this.form.isApplied = true
                this.form.applyPreviousName = applyPreviousName
            }
            this.form.howLearned = data.howLearned
            this.form.howLearnedOther = data.howLearnedOther
            this.form.howLearnedOther1 =data.howLearnedOther1
            this.form.expectedHours = data.expectedHours
            this.form.applyPosition = data.applyPosition
            var list2=[]
           
            var newArr = data.dentalOfficeManagmentSoftware.split('|')
            let keys = ['Archy','Carestack','Cloud9','Dolphin','DOX','Fuse','iDentalsoft','OMS Vision','Ortho Edge','Ortho Trac',
            'Oryx','Perio Vision','Practice Web','Sensei Cloud','Tab 32','TDO','Wave Ortho','Curve','Dentrix','Eaglesoft',
            'Easy Dental','Practice Works','Open Dental',
            'Mac Practice','Dentimax','Softdent','Enterprise','Ascend','Endo Vision','WinOMS','DSN',
            'TOPS','Denticon/Planet DDS','XLDent','QSI','PBS']
            //1.start 解析脏数据dentalOfficeManagmentSoftware
            let hasOther = this.hasOtherInArray(newArr,keys)
            if(hasOther.hasFill&&!newArr.includes('Other')){
                this.form.dentalOfficeManagmentSoftwareOther = hasOther.item.split('[')[0]
                data.dentalOfficeManagmentSoftware+='|Other'+hasOther.item
            }else{
                this.form.dentalOfficeManagmentSoftwareOther = data.dentalOfficeManagmentSoftwareOther
            }
            newArr = data.dentalOfficeManagmentSoftware.split('|')
            //end
            if(newArr){
                for(var i=0;i<newArr.length;i++){
                    var k =-1
                    var item = newArr[i]
                    if(item.indexOf('Curve')>=0){
                        k=0
                        list2.push('Curve')
                    }
                    if(item.indexOf('Archy')>=0){
                        k=29
                        list2.push('Archy')
                    }
                    if(item.indexOf('Carestack')>=0){
                        k=30
                        list2.push('Carestack')
                    }
                    if(item.indexOf('Cloud9')>=0){
                        k=31
                        list2.push('Cloud9')
                    }
                    if(item.indexOf('Dolphin')>=0){
                        k=32
                        list2.push('Dolphin')
                    }
                    if(item.indexOf('DOX')>=0){
                        k=33
                        list2.push('DOX')
                    }
                    if(item.indexOf('Fuse')>=0){
                        k=34
                        list2.push('Fuse')
                    }
                    if(item.indexOf('iDentalsoft')>=0){
                        k=35
                        list2.push('iDentalsoft')
                    }
                    if(item.indexOf('OMS Vision')>=0){
                        k=36
                        list2.push('OMS Vision')
                    }
                    if(item.indexOf('Ortho Edge')>=0){
                        k=37
                        list2.push('Ortho Edge')
                    }
                    if(item.indexOf('Ortho Trac')>=0){
                        k=38
                        list2.push('Ortho Trac')
                    }
                    if(item.indexOf('Perio Vision')>=0){
                        k=39
                        list2.push('Perio Vision')
                    }
                    if(item.indexOf('Practice Web')>=0){
                        k=40
                        list2.push('Practice Web')
                    }
                    if(item.indexOf('Sensei Cloud')>=0){
                        k=41
                        list2.push('Sensei Cloud')
                    }
                    if(item.indexOf('Tab 32')>=0){
                        k=42
                        list2.push('Tab 32')
                    }
                    if(item.indexOf('TDO')>=0){
                        k=43
                        list2.push('TDO')
                    }
                    if(item.indexOf('Wave Ortho')>=0){
                        k=44
                        list2.push('Wave Ortho')
                    }
                    if(item.indexOf('Oryx')>=0){
                        k=45
                        list2.push('Oryx')
                    }
                    if(item.indexOf('Dentrix')>=0) {
                        k=1
                        list2.push('Dentrix')
                    }
                    if(item.indexOf('Eaglesoft')>=0) {
                        k=2
                        list2.push('Eaglesoft')
                    }
                    if(item.indexOf('Easy Dental')>=0) {
                        k=3
                        list2.push('Easy Dental')
                    }
                    if(item.indexOf('Practice Works')>=0) {
                        k=4
                        list2.push('Practice Works')
                    }
                    if(item.indexOf('Open Dental')>=0) {
                        k=5
                        list2.push('Open Dental')
                    }
                    if(item.indexOf('Mac Practice')>=0) {
                        k=7
                        list2.push('Mac Practice')
                    }
                    if(item.indexOf('Dentimax')>=0) {
                        k=8
                        list2.push('Dentimax')
                    }
                    if(item.indexOf('Softdent')>=0) {
                        k=9
                        list2.push('Softdent')
                    }
                    if(item.indexOf('Enterprise')>=0) {
                        k=10
                        list2.push('Enterprise')
                    }
                    if(item.indexOf('Ascend')>=0){
                        k=11
                        list2.push('Ascend')
                    }
                    if(item.indexOf('Endo Vision')>=0){
                        k=13
                        list2.push('Endo Vision')
                    }
                    if(item.indexOf('WinOMS')>=0){
                        k=14
                        list2.push('WinOMS')
                    }
                    if(item.indexOf('DSN')>=0){
                        k=15
                        list2.push('DSN')
                    }
                    if(item.indexOf('TOPS')>=0){
                        k=18
                        list2.push('TOPS')
                    }
                    if(item.indexOf('Denticon/Planet DDS')>=0){
                        k=19
                        list2.push('Denticon/Planet DDS')
                    }
                    if(item.indexOf('XLDent')>=0){
                        k=21
                        list2.push('XLDent')
                    }
                    if(item.indexOf('QSI')>=0){
                        k=23
                        list2.push('QSI')
                    }
                    if(item.indexOf('PBS')>=0){
                        k=24
                        list2.push('PBS')
                    }
                    if(item.indexOf('Daisy')>=0){
                        k=25
                        list2.push('Daisy')
                    }
                    if(item.indexOf('Primident')>=0){
                        k=23
                        list2.push('Primident')
                    }
                    if(item.indexOf('Medical Billing')>=0){
                        k=27
                        list2.push('Medical Billing')
                    }
                    if(item.indexOf('Other')>=0){
                        k=28
                        list2.push('Other')
                    }
                    console.log(k);
                    if(item.indexOf('1 year')>=0){
                        this.dentalList['item'+(k+1)]='1 year'
                    } else if(item.indexOf('1-3 year')>=0){
                        this.dentalList['item'+(k+1)]='1-3 year'
                    } else if(item.indexOf('3+ year')>=0){
                        this.dentalList['item'+(k+1)]='3+ year'
                    }
                }
                this.form.dentalOfficeManagmentSoftware = list2
            }

            //start 解析mostProficientSoftware脏数据 
            let hasOtherInProficient = this.hasOtherInArray([data.mostProficientSoftware],keys)
            if(hasOtherInProficient.hasFill){
                this.form.mostProficientSoftware = 'Other'
                this.form.mostProficientSoftwareOther = data.mostProficientSoftware
            }else{
                this.form.mostProficientSoftware = data.mostProficientSoftware
            }
            //end
            var list3=[]
            var dentalSpecialties = data.dentalSpecialties
            if(dentalSpecialties){
                if(dentalSpecialties.indexOf('Orthodontics')>=0)list3.push('Orthodontics')
                if(dentalSpecialties.indexOf('Oral Surgery')>=0)list3.push('Oral Surgery')
                if(dentalSpecialties.indexOf('Periodontal')>=0)list3.push('Periodontal')
                if(dentalSpecialties.indexOf('General Practice')>=0)list3.push('General Practice')
                if(dentalSpecialties.indexOf('Pedodontics')>=0)list3.push('Pedodontics')
                if(dentalSpecialties.indexOf('Prosthodontics')>=0)list3.push('Prosthodontics')
                if(dentalSpecialties.indexOf('None')>=0)list3.push('None')
            }
            this.form.dentalSpecialties=list3
            this.form.currentlyOnPracticeSoftware = data.currentlyOnPracticeSoftware || '';
            this.form.currentlyOnPracticeSoftwareOther = data.currentlyOnPracticeSoftwareOther || '';

            var list5=[]
            var haveExperienceWith = data.haveExperienceWith
            if(haveExperienceWith){
                if(haveExperienceWith.indexOf('Bookkeeping experience')>=0)list5.push('Bookkeeping experience')
                if(haveExperienceWith.indexOf('QuickBooks Certifield')>=0)list5.push('QuickBooks Certifield')
                if(haveExperienceWith.indexOf('Dental Accounting using QuickBooks')>=0)list5.push('Dental Accounting using QuickBooks')
                if(haveExperienceWith.indexOf('Medical Billing')>=0)list5.push('Medical Billing')
                if(haveExperienceWith.indexOf('Billing Medicaid')>=0)list5.push('Billing Medicaid')
                if(haveExperienceWith.indexOf('Billing DMO')>=0)list5.push('Billing DMO')
                if(haveExperienceWith.indexOf('Dentical - California Medicaid')>=0)list5.push('Dentical - California Medicaid')
                if(haveExperienceWith.indexOf('Auditing accounts and sending patient statements')>=0)list5.push('Auditing accounts and sending patient statements')
                if(haveExperienceWith.indexOf('None of the above')>=0)list5.push('None of the above')
                this.form.haveExperienceWith = list5
            }
            this.form.browser = data.browser
            this.form.isUsingPC = data.isUsingPC
            var list6=[]
            //start 解析education脏数据
            var education = data.education
            let educationArr=['No college','Some college','College degree','Graduate degree','Vocational vetting','None']
            let checkEduArr = data.education.split('|')
            let edu = this.hasOtherInArray(checkEduArr,educationArr)
            if(edu.hasFill&&!checkEduArr.includes('Other')){
                education+='|Other'
                this.form.educationOther = edu.item
            }else{
                this.form.educationOther = data.educationOther
            }
            //end
            if(education){
                if(education.indexOf('No college')>=0)list6.push('No college')
                if(education.indexOf('Some college')>=0)list6.push('Some college')
                if(education.indexOf('College degree')>=0)list6.push('College degree')
                if(education.indexOf('Graduate degree')>=0)list6.push('Graduate degree')
                if(education.indexOf('Vocational vetting')>=0)list6.push('Vocational vetting')
                if(education.indexOf('None')>=0)list6.push('None')
                this.form.education = list6
            }
            // this.form.educationOther = data.educationOther

            var list7 = []
            var frontOfficeSkillSet = data.frontOfficeSkillSet
            if(frontOfficeSkillSet){
                if(frontOfficeSkillSet.indexOf('I understand how to read ledgers')>=0)list7.push('I understand how to read ledgers')
                if(frontOfficeSkillSet.indexOf('I know how to post EOBs and all adjustments on patient accounts')>=0)list7.push('I know how to post EOBs and all adjustments on patient accounts')
                if(frontOfficeSkillSet.indexOf('I am competent at getting insurance companies to pay claims that are denied')>=0)list7.push('I am competent at getting insurance companies to pay claims that are denied')
                if(frontOfficeSkillSet.indexOf('I know how to work an aging report')>=0)list7.push('I know how to work an aging report')
                if(frontOfficeSkillSet.indexOf('I know how to send electronic claims')>=0)list7.push('I know how to send electronic claims')
                if(frontOfficeSkillSet.indexOf('I know how to send electronic attachments')>=0)list7.push('I know how to send electronic attachments')
                if(frontOfficeSkillSet.indexOf('I know how to use eFax')>=0)list7.push('I know how to use eFax')
                if(frontOfficeSkillSet.indexOf('None')>=0)list7.push('None')
                this.form.frontOfficeSkillSet = list7
            }

            var list8=[]
            var computerSkillLevel = data.computerSkillLevel
            if(computerSkillLevel){
                if(computerSkillLevel.indexOf('I can build or fix a PC')>=0)list8.push('I can build or fix a PC')
                if(computerSkillLevel.indexOf('I help others with computer problems')>=0)list8.push('I help others with computer problems')
                if(computerSkillLevel.indexOf('My PCs often get infected with viruses')>=0)list8.push('My PCs often get infected with viruses')
                if(computerSkillLevel.indexOf('I am able to clean a virus off a PC')>=0)list8.push('I am able to clean a virus off a PC')
                if(computerSkillLevel.indexOf('I get others to help me with my PC from time to time')>=0)list8.push('I get others to help me with my PC from time to time')
                if(computerSkillLevel.indexOf('I am proficient in MS Office (word, excel, etc)')>=0)list8.push('I am proficient in MS Office (word, excel, etc)')
                if(computerSkillLevel.indexOf("I don't own a computer")>=0)list8.push("I don't own a computer")
                this.form.computerSkillLevel = list8
            }
            this.form.isEmployed = data.isEmployed
            this.form.IsWorkedForEAsssitClient = data.isWorkedForEAsssitClient
            this.form.whenWork = data.whenWork.split('|')
            this.form.whenWorkOther = data.whenWorkOther
            this.form.whatInterested = data.whatInterested?.split('|') ?? []
            this.form.internetServiceProvider = data.internetServiceProvider
            this.form.typeOfInternetConnection = data.typeOfInternetConnection
            this.form.pingResults = data.pingResults
            this.form.downloadSpeed = data.downloadSpeed
            this.form.uploadSpeed = data.uploadSpeed
            this.form.academicHonors = data.academicHonors
            this.form.specializedTraining = data.specializedTraining
            this.form.allDentalOfficeEmployment = data.allDentalOfficeEmployment
            this.form.medicaidExperienceOther = data.medicaidExperienceOther
            this.form.IsInterestedLearnPracticeSoftware = data.isInterestedLearnPracticeSoftware
            this.form.IsWillingPayToTeach = data.isWillingPayToTeach
            var referenceList = data.referenceList
            if(referenceList){
                var list9=[]
                var newArr1 = referenceList.split('\n')
                for(var n =0;n<newArr1.length;n++){
                    var item1=newArr1[n]
                    if(item1.length>0){
                        var obj={}
                        var newArr2 = item1.split(',')
                        for(var m=0;m<newArr2.length;m++){
                            if(newArr2[m].indexOf("Name")>=0)obj.name = newArr2[m].replace('Name:','')
                            if(newArr2[m].indexOf("Address")>=0)obj.address = newArr2[m].replace('Address:','')
                            if(newArr2[m].indexOf("Phone number")>=0)obj.phone = newArr2[m].replace('Phone number:','')
                            if(newArr2[m].indexOf("Relationship / occupation")>=0)obj.occupation = newArr2[m].replace('Relationship / occupation:','')
                            if(newArr2[m].indexOf("Year")>=0)obj.year = newArr2[m].replace('Year:','')
                        }
                        list9.push(obj)
                    }
                }
            this.form.referenceList = list9
                console.log('newArr',newArr1)
            }
            this.form.signature = data.signature
            // this.form.mostProficientSoftwareOther = data.mostProficientSoftwareOther
            this.form.resumeUrl = data.resumeUrl
            this.form.uploadScreenShotUrl = data.uploadScreenShotUrl
            this.form.isAccepted = true
            this.form.haveWorked = data.haveWorked
            this.form.haveWorkedOffice = data.haveWorkedOffice
            // this.form.dentalOfficeManagmentSoftwareOther = data.dentalOfficeManagmentSoftwareOther
            var list1=[]
            if(data.medicaidExperience){
                if(data.medicaidExperience.indexOf('Denti-Cal')>=0)list1.push('Denti-Cal')
                if(data.medicaidExperience.indexOf('None')>=0)list1.push('None')
                if(data.medicaidExperience.indexOf('Other Medicaid Plans')>=0)list1.push('Other Medicaid Plans')
                this.form.medicaidExperience=list1
            }
        },
        changePhone() {
            console.log('changePhone')
            this.form.phone = this.phone
            console.log(this.form.phone)
        },
        changeAccept() {
            if(this.form.isAccepted){
                this.acceptFail = false
            }
        },
        del(index) {
            this.form.referenceList.splice(index,1)
        },
        addItem() {
            this.form.referenceList.push({name:'',address:'',phone:'',occupation:'',year:''})
        },
        changeCode() {
            if(this.form.zipCode.length == 5) {
                this.$axios.get('https://zip.getziptastic.com/v2/US/'+this.form.zipCode).then(res => {
                    // console.log(res)
                    this.form.city = res.city
                    this.form.state = res.state
                })
            }else if(this.form.zipCode.length == 6) {
                this.$axios.get('https://zip.getziptastic.com/v2/CA/'+this.form.zipCode).then(res => {
                    this.form.city = res.city
                    this.form.state = res.state
                })
            }
        },
        uploadSuccess(res) {
            console.log(res)
            this.form.resumeUrl = res.data.url
        },
        edit() {
            if(this.isAdmin)return
            if(this.$refs&&this.$refs['resumeUrl'])this.$refs['resumeUrl'].click()
        },
        remove() {
            if(this.isAdmin)return
            this.form.resumeUrl = ''
        },
        edit1() {
            if(this.isAdmin)return
            if(this.$ref&&this.$refs['upload1'])this.$refs['upload1'].click()
        },
        remove1() {
            if(this.isAdmin)return
            this.form.uploadScreenShotUrl = ''
        },
        uploadSuccess1(res) {
            console.log(res)
            this.form.uploadScreenShotUrl = res.data.url
        },
        editApply(){
            this.isAdmin=false
        },
        trim(str){
            var res=''
            for(var i=0;i<str.length;i++){
                var char = str[i]
                if(char!==' ')res+=char
            }
            return res
        },
        submit() {
            console.log('submit');
            console.log(this.form.available);
            this.disableCityAndState = false
            this.form.phone = this.phone
            this.$refs['form'].clearValidate()
            if(this.$route.query.model&&this.$route.query.model=='review'){
                this.form.password='$'
                this.form.password2='$'
                this.form.resumeUrl='$'
                this.form.uploadScreenShotUrl='$'
            }
            this.$nextTick(() => {
                let listStr = ''
                this.form.referenceList.forEach(n => {
                    listStr += 'Name: ' +n.name+', Address: '+n.address+', Phone number: '+n.phone+', Relationship / occupation: '+n.occupation+', Year: '+n.year+'\n';
                })
                this.$refs['form'].validate((valid,object) => {
                    if (valid) {
                        console.log(this.form)
                        var signature = this.trim(this.form.signature).toLowerCase()
                        var firstName = this.trim(this.form.firstName).toLowerCase()
                        var lastName = this.trim(this.form.lastName).toLowerCase()
                        if(signature!=firstName + lastName){
                            this.signFail = true
                            return
                        }else{
                            this.signFail = false
                        }
                        if(!this.form.isAccepted){
                            this.acceptFail = true
                            return
                        }else{
                            this.acceptFail = false
                        }
                        if(!this.form.available){
                            this.consentFail = true
                            return
                        }else{
                            this.consentFail = false
                        }
                        this.loading=true
                        let languagesArr = []
                        this.form.languages.forEach((n,i) => {
                            if(n.indexOf('Other')>=0){
                                languagesArr.push('Other:'+this.form.languagesOther)
                            }else{
                                languagesArr.push(n)
                            }
                        })
                        var form =  {
                            applyPosition:this.form.applyPosition,
                            firstName:this.form.firstName,
                            middleName:this.form.middleName,
                            lastName:this.form.lastName,
                            preferredName:this.form.preferredName,
                            email:this.form.email,
                            password:this.form.password,
                            password2:this.form.password2,
                            phone:this.form.phone,
                            address:this.form.address,
                            city:this.form.city,
                            state:this.form.state,
                            zipCode:this.form.zipCode,
                            country:this.form.country,
                            expectedSalary:this.form.expectedSalary,
                            available: this.form.available,
                            yearsDentalExperience:this.form.yearsDentalExperience,
                            yearsFrontOfficeExperience:this.form.yearsFrontOfficeExperience,
                            languages:languagesArr.join('|'),
                            typingSpeed:this.form.typingSpeed,
                            isApplied:this.form.isApplied,
                            previousApplication: this.form.previousApplication == ''? '': moment(this.form.previousApplication).format("YYYY-MM-DD HH:mm:ss"),
                            ableToWorkInUS:this.form.ableToWorkInUS,
                            over18:this.form.over18,
                            felony:this.form.felony,
                            familyAteAssist:this.form.familyAteAssist?this.form.familyAteAssistName:'',
                            applyPreviousName:this.form.applyPreviousName,
                            howLearned:this.form.howLearned,
                            howLearnedOther:this.form.howLearnedOther,
                            howLearnedOther1:this.form.howLearnedOther1,
                            expectedHours:this.form.expectedHours,
                            medicaidExperience:setSubmitValue(this.form.medicaidExperience),
                            dentalOfficeManagmentSoftware:setSubmitValue1(this.form.dentalOfficeManagmentSoftware, this.dentalList),
                            medicaidExperienceOther:this.form.medicaidExperienceOther,
                            currentlyOnPracticeSoftware: this.form.currentlyOnPracticeSoftware,
                            currentlyOnPracticeSoftwareOther:this.form.currentlyOnPracticeSoftwareOther,
                            mostProficientSoftware:this.form.mostProficientSoftware,
                            mostProficientSoftwareOther:this.form.mostProficientSoftwareOther,
                            dentalSpecialties:setSubmitValue(this.form.dentalSpecialties),
                            haveExperienceWith:setSubmitValue(this.form.haveExperienceWith),
                            resumeUrl:this.form.resumeUrl,
                            uploadScreenShotUrl:this.form.uploadScreenShotUrl,
                            browser:this.form.browser,
                            isUsingPC:this.form.isUsingPC,
                            education:setSubmitValue(this.form.education),
                            educationOther:this.form.educationOther,
                            frontOfficeSkillSet:setSubmitValue(this.form.frontOfficeSkillSet),
                            computerSkillLevel:setSubmitValue(this.form.computerSkillLevel),
                            isEmployed:this.form.isEmployed,
                            IsWorkedForEAsssitClient:this.form.IsWorkedForEAsssitClient,
                            haveWorkedOffice:this.form.haveWorkedOffice,
                            whenWork:this.form.whenWork.join('|'),
                            whenWorkOther:this.form.whenWorkOther,
                            whatInterested:this.form.whatInterested.join('|'),
                            internetServiceProvider:this.form.internetServiceProvider,
                            typeOfInternetConnection:this.form.typeOfInternetConnection,
                            pingResults:this.form.pingResults,
                            downloadSpeed:this.form.downloadSpeed,
                            uploadSpeed:this.form.uploadSpeed,
                            academicHonors:this.form.academicHonors,
                            specializedTraining:this.form.specializedTraining,
                            allDentalOfficeEmployment:this.form.allDentalOfficeEmployment,
                            checkReferenceList:'has value',
                            referenceList:listStr,
                            signature:this.form.signature,
                            isAccepted:this.form.isAccepted,
                            haveWorked:this.form.haveWorked,
                            dentalOfficeManagmentSoftwareOther:this.form.dentalOfficeManagmentSoftwareOther,
                            IsWillingPayToTeach:this.form.IsWillingPayToTeach,
                            IsInterestedLearnPracticeSoftware:this.form.IsInterestedLearnPracticeSoftware
                        }
                        var url=''
                        if(this.$route.query.model&&this.$route.query.model=='review'){
                            url=this.$URL.updateApplyUrl
                            form.applicantId = this.applicantID
                            form.previousApplication = ''
                        }else{
                            url=this.$URL.applyUrl
                            form.version = this.form.version
                        }
                    //    console.error('传参是',form)
                    //    return
                        this.$axios.post(url,form).then((res) => {
                            this.loading=false
                            if(res.code==0){
                                console.log('apply success！')
                                this.$message.success({message:res.msg})
                                if(this.$route.query.model&&this.$route.query.model=='review'){
                                    this.isAdmin=true
                                    return
                                }
                                localStorage.setItem('token', res.data.token)
                                localStorage.setItem('email',res.data.email)
                                localStorage.setItem('tokenType',res.data.tokenType)
                                this.$store.commit('saveService',{})
                                this.$store.commit('savePositionInfo',{})
                                setTimeout(()=>{
                                    this.$router.push('/applicantHome')
                                },200)
                            }else{
                                this.$message.error({message:res.msg})
                            }
                            console.log(res)
                        }).catch((err) => {
                            this.loading=false
                            this.$message.error({message:err})
                            console.log(err)
                        })
                    } else {
                        // setTimeout(()=>{
                        //     var isError= document.getElementsByClassName("is-error");
                        //     isError[0].querySelector('input').focus();
                        // },1)

                        let dom = this.$refs[Object.keys(object)[0]]
                        if(dom)dom.$el.scrollIntoView({
                            //滚动到指定节点
                            block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                            behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                        })
                        console.log('error submit!!');
                        return false;
                    }
                });
            })
        },
        getData(){
            console.log('验证码是', chat2Ascii('835942293@qq.com'))
            if(this.$route.query.model=='review'&&this.$route.query.verify){
                var email = this.$route.query.email
                var verify = this.$route.query.verify
                var verifyCode = chat2Ascii(email)
                // console.log('验证码是',verifyCode)
                if(verifyCode!=verify){
                    this.isAdmin=false
                    this.$router.push('/login')
                    return
                }
                this.isAdmin=true
                if(!email)return
                this.$axios.get(this.$URL.applyInfo,{params:{email:email}}).then(res=>{
                    if(res.code==0){
                        console.log('返回的注册信息',res);
                         var data = res.data
                        //  localStorage.setItem('applyPosition',data.applyPosition)
                        this.applicantID=data.applicantID
                        if(data!=null)
                            this.deconstructData(data)
                    }
                }).catch(err=>{
                    this.$message.error({message:err})
                })
            }else{
                this.getVersion();
                this.$refs.firstName.focus()
            }
        },
        getVersion(){
          var switchUrl = getCookie("select_page_user_has_enter");
          console.log(switchUrl);
          if(switchUrl != undefined) {
            var decodeUrl = decodeURIComponent(switchUrl);
            console.log(decodeUrl);
            if(decodeUrl.startsWith("https://application.eassist.me")) {
              this.form.version = 5;
            }
          } 
        }
    },
    mounted() {
        this.origin = this.$axios.defaults.baseURL
        this.getData()
    },
    watch:{
        '$route'(to,from){
            if(to.path==='/apply'){
                console.log(from);
                this.getData()
            }
        }
    },
    directives: {
		mask: mask,
	}
}
</script>
<style lang="less" scoped>
    .header{
        // height:100px;
        background:#2dc3e3;
        padding:20px;
        position:relative;
    }
    .main{
        display: flex;
        width:100%;

        section{
            background:#f3f3f3;
            flex:1;
            width:100%;
        }
    }
    section{
        padding:70px 30px
    }
    .specialItem{
        margin-left: -200px;
        /deep/ .el-form-item__error{
            margin-left: 10px;
        }
    }
    .underLine{
        text-decoration: underline
    }
    /deep/ .hideInput .el-input__inner{
        height: 0px!important;
        border: none;
    }
    .hideInput{
        position: absolute;
        top:0px
    }
    .manually{
        vertical-align: bottom;
        margin-bottom: 20px;
    }
</style>
